import { APP_CONSTANTS } from "../../core/config/appConstants";
import Container from "../../shared/components/Container/Container";
import useTitle from "../../core/hooks/useTitle";

const TooManyTries = () => {
	useTitle("Bestätigung nicht möglich");

	const buttons = [
		{
			label: "Zu Telekom.de",
			variant: "primary",
			onClick: () =>
				(window.location.href =
					APP_CONSTANTS.LINK.TELEKOM),
			size: "small",
			tabIndex: 1,
			ariaLabel: "Link zu Telekom.de"
		}
	];
	const icons = [
		{
			name: "error-type-standard",
			size: 64,
			color: "var(--color-error)"
		}
	];

	return (
		<Container
			title="Bestätigung nicht möglich"
			description="Die Daten wurden leider zu häufig fehlerhaft eingegeben. Aus Sicherheitsgründen kann die E-Mail-Adresse nicht bestätigt werden."
			buttons={buttons}
			icon={icons[0]}
		></Container>
	);
};

export default TooManyTries;
